import { computed } from 'vue'
import { useDisplay } from 'vuetify'

export function useBreakpoints() {
  const display = useDisplay()

  const isMobile = computed(() => display.smAndDown.value)
  const isTablet = computed(() => display.md.value)
  const isDesktop = computed(() => display.lgAndUp.value)
  // "Narrow" = phone + tablet (< 1280, Vuetify's `lg` start). Used where a right-hand panel should
  // overlay instead of reserving layout width, so narrow/tablet viewports aren't left with empty space.
  const isNarrow = computed(() => display.mdAndDown.value)

  return { isMobile, isTablet, isDesktop, isNarrow }
}
